import { createContext } from 'react';
import type { FileHistoryContextType } from './types';

const FileHistoryContext = createContext<FileHistoryContextType>(
  {} as FileHistoryContextType,
);

export default FileHistoryContext;
